import { getItemFromCollection } from "directus/src/operations";

export async function fetchCurrenciesData({ currencyId }) {
  try {
    const response = await getItemFromCollection("currencies", currencyId);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
